<template>
  <div>
    <div v-if="$route.path.indexOf('_detail') === -1">
      <el-table :data="dconfData"  v-loading="loading"  @selection-change="handleSelectionChange">
        <el-table-column type="selection" align="center" label="全选"></el-table-column>
        <el-table-column prop="id" label="ID" width="130"></el-table-column>
        <el-table-column prop="title" label="名称" width="130"></el-table-column>
        <el-table-column prop="content" label="翻倍比例" width="130"></el-table-column>
        <el-table-column prop="is_open" label="状态" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.is_open=='1'">启用</el-tag>
            <el-tag v-else type="danger">关闭</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="130">
          <template slot-scope="scope">
            <el-button type="text" @click="editInfo(scope.row)" class="btn-gap">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
     <div v-if="total_count > params.pageSize" class="content-padded tc">
      <el-pagination background   layout="prev, pager, next, total" @current-change="handleCurrentChange" :current-page.sync="params.page" :total='total_count' :page-size='params.pageSize'>
      </el-pagination>
    </div>

      <el-dialog  :title="dialogTitle" class="right-dialog" :visible.sync="editInfoDialog" :before-close="handleCancelLabelsDialog">
      <template>
        <el-form>
          <el-form-item label-width="100px" label="翻倍比例">
            <el-input v-model="updateForm.content" placeholder="翻倍比例"></el-input>
          </el-form-item>
          <el-form-item label-width="100px" label="状态">
            <el-radio-group v-model="updateForm.is_open" size="small">
              <el-radio-button :label="'0'">关闭</el-radio-button>
              <el-radio-button :label="'1'">启用</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item class="content-center">
            <el-button type="primary" @click="editInfoSubmit()">确定</el-button>
          </el-form-item>
        </el-form>
      </template>
    </el-dialog>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import {doubleCommission, updateDoubleCommission} from '../../../api/sharer'
export default {
  components: { },
  data () {
    return {
      total_count: 0,
      dialogTitle: '',
      loading: false,
      dconfData: [],
      params: {
        page: 1,
        pageSize: 20
      },
      updateForm: {
        id: '',
        content: '',
        is_open: ''
      },
      editInfoDialog: false
    }
  },
  methods: {
    getDoubleCommission (filter) {
      this.loading = true
      doubleCommission(filter).then(response => {
        this.dconfData = response.data.data.list
        this.total_count = Number(response.data.data.total_count)
        this.loading = false
      })
    },
    editInfo (row = '') {
      this.editInfoDialog = true
      if (row) {
        this.updateForm.id = row.id
        this.updateForm.content = row.content
        this.updateForm.is_open = row.is_open
      } else {
        this.dialogTitle = '佣金翻倍设置'
      }
    },
    editInfoSubmit () {
      var status = '关闭'
      if (this.updateForm.is_open === 1) {
        var status = '启用'
      }
      if (this.updateForm.content > 2 || this.updateForm.content <= 1) {
          alert('翻倍比例设置有风险!!!')
        return false
      }
      var msg = '翻倍比例为' + this.updateForm.content + ', 状态为' + status + ' 确定要这样修改吗?'
      this.$confirm(msg, '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            updateDoubleCommission({id: this.updateForm.id, content: this.updateForm.content, is_open: this.updateForm.is_open}).then(res => {
              this.$message({ type: 'success', message: '更新成功'})
              this.editInfoDialog = false
              this.getDoubleCommission(this.params)
            })
          }
          done()
        }
      })
    },
    handleCancelLabelsDialog () {
      this.editInfoDialog = false
    },
    handleSelectionChange (val) {
      console.log(val)
    },
    handleCurrentChange (val) {
      this.params.page = val
      this.getDoubleCommission(this.params)
    }
  },
  mounted () {
    this.getDoubleCommission(this.params)
    let param = {
      page: 1,
      pageSize: 100
    }
  },
  watch: {
    // 分页全选-监听数据变化
    dconfData: {
      handler (value) {
        if (this.allCheck) {
          this.dconfData.forEach(row => {
            if (row) {
              this.$refs.multipleTable.toggleRowSelection(row, true)
            }
          })
        }
      },
      deep: true
    }
  }
}
</script>
<style>
.frm-tips {
  color: #e76c34;
}
</style>



// WEBPACK FOOTER //
// double_commission.vue?d62823de